var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegulationSummary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18036_4829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7366 21.3167H41.6866V2.0334H10.8732V16.2301H8.82324V-0.0166016H43.7366V21.3167Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 23.6833L18.75 19.4467H4.75L2.05 36.2333V10.9H5.61V8.84668H0V48H0.17H43.37L48 23.6833H23ZM41.6667 45.95H2.57L6.48333 21.4967H17.9033L22.14 25.7333H45.5233L41.6667 45.95Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9299 8.84668H16.6299V10.8967H35.9299V8.84668Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9301 16.6133H25.4167V18.6633H35.9301V16.6133Z",
    fill: "#415385"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18036_4829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulationSummary);
export default __webpack_public_path__ + "static/media/regulation-summary.754b5881b3947299f6796a8989e7885a.svg";
export { ForwardRef as ReactComponent };